import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import { getErpgoodsList } from '@/services/customer/erpCustomerList';
import product_default from '@/assets/img/product_default.png';

/* function onChange(pagination, filters, sorter) {
	console.log('params', pagination, filters, sorter);
} */

export default {
  name: 'productList',
  i18n: require('./i18n-customer'),
  watch: {},
  props: {
    erpcustomerId: {
      type: [Number, String],
      default: null
    }
  },
  data: function data() {
    var columns = [{
      // 商品信息
      title: this.$t('erpGoods.goodsContent'),
      dataIndex: 'productName',
      key: 'productName',
      scopedSlots: {
        customRender: 'productNameScopedSlots'
      },
      width: '15%',
      ellipsis: true
    },
    // 得意先信息
    // {
    // 	title:this.$t('erpGoods.erpContent'),
    // 	dataIndex: 'erpcontent',
    // 	key: 'erpcontent',
    //     scopedSlots: {
    // 		customRender: 'erpcontent'
    // 	},
    // 	width: '10%'
    // },
    // 类型
    // 	{
    // 	title: this.$t('erpGoods.goodsType'),
    // 	dataIndex: 'goodStatus',
    // 	key: 'goodStatus',
    //      scopedSlots: {
    // 		customRender: 'goodStatus'
    // 	},
    // 	width: '6%'
    // },
    {
      title: 'JAN',
      dataIndex: 'janCode',
      key: 'janCode',
      scopedSlots: {
        customRender: 'janCode'
      },
      width: '9%'
    },
    // 运输温度
    {
      title: this.$t('erpGoods.transport'),
      dataIndex: 'transport',
      key: 'transport',
      scopedSlots: {
        customRender: 'transport'
      },
      width: '8%'
    },
    // 品牌
    {
      title: this.$t('erpGoods.brand'),
      dataIndex: 'productBrand',
      key: 'productBrand',
      scopedSlots: {
        customRender: 'productBrand'
      },
      width: '8%'
    },
    // 原产地
    {
      title: this.$t('erpGoods.source'),
      dataIndex: 'productSourcearea',
      key: 'productSourcearea',
      scopedSlots: {
        customRender: 'productSourcearea'
      },
      width: '5%'
    },
    // 容量入数
    {
      title: this.$t('erpGoods.rongliang'),
      dataIndex: 'rongliang',
      key: 'rongliang',
      scopedSlots: {
        customRender: 'rongliang'
      },
      width: '8%'
    },
    // 上次购买时间
    {
      title: this.$t('erpGoods.lastBuy'),
      dataIndex: 'lastBuyDate',
      key: 'lastBuyDate',
      scopedSlots: {
        customRender: 'lastBuyDate'
      },
      width: '8%',
      sorter: true
    },
    // 更新时间
    {
      title: this.$t('erpGoods.updateTime'),
      dataIndex: 'lastUpdateTime',
      key: 'lastUpdateTime',
      scopedSlots: {
        customRender: 'updateTimeScopedSlots'
      },
      // sorter:  (a, b) => { return a.lastUpdateTime> b.lastUpdateTime? 1 : -1 },
      // defaultSortOrder: 'descend',
      width: '8%',
      sorter: true,
      defaultSortOrder: 'descend'
    }];
    return {
      productDefaultImg: product_default,
      leftCurrencySymbol: localStorage.getItem('leftCurrencySymbol'),
      rightCurrencySymbol: localStorage.getItem('rightCurrencySymbol'),
      totalNum: 0,
      cloneQueryParam: {},
      page: 1,
      size: 20,
      queryParam: {
        type: 1,
        //排序类型 1更新时间 2购买时间
        searchkeyword: '',
        //搜索内容
        productType: 1,
        //商品类型 （1全部 2自定义商品）
        sort: 0,
        //查询类型 升序/降序
        erpCustomerId: undefined //得意先id
      },
      //展开  收起
      showAdvanced: false,
      columns: columns,
      isTableLoading: false,
      //表格勾选行
      //首选运输方式基础数据
      transportModeList: [],
      // 类型数据 固定的 系统商品，已购商品  自定义商品
      typeList: [{
        name: this.$t('customerList.all'),
        id: 1
      }, {
        name: this.$t('customerList.selfDefine'),
        id: 2
      }
      // {name:'自定义商品',id:2 },
      ],
      //品牌基础数据
      brandList: [],
      //原产地基础数据
      sourceAreaList: [],
      // queryLoading: false,
      productList: []
    };
  },
  computed: {},
  mounted: function mounted() {
    this.getProductList();
    //获取路由参数query
    // this.init();
  },
  methods: {
    //初始化
    // async init() {
    // let self = this;
    // self.queryLoading = true;
    // self.getProductList();
    //获取运输方式列表
    // getTransport().then(response => {
    // 	if (response.data.code == 200) {
    // 		self.transportModeList = response.data.data;
    // 	}
    // });
    // let getObj = {
    // 	statusType: 2
    // };
    // 品牌
    // getBrand(getObj).then(response => {
    // 	if (response.data.code == 200) {
    // 		self.brandList = response.data.data;
    // 	}
    // });
    // 原产地
    // getSourcearea(getObj).then(response => {
    // 	if (response.data.code == 200) {
    // 		self.sourceAreaList = response.data.data;
    // 	}
    // });
    // self.queryLoading = false;
    //				console.log(self.classifyList);
    // },
    // queryProductList() {
    // 	this.page = 1
    // 	this.getProductList();
    // },
    //获取商品列表
    getProductList: function getProductList() {
      console.log('子组件');
      var self = this;
      self.isTableLoading = true;
      self.queryParam.erpCustomerId = this.erpcustomerId;
      getErpgoodsList(self.queryParam).then(function (response) {
        if (response.data.code == 200) {
          console.log(response, 'res................');
          self.productList = response.data.data.productlist;
        }
      }).finally(function () {
        self.isTableLoading = false;
      });
    },
    tableChange: function tableChange(pagination, filters, sorter, _ref) {
      var currentDataSource = _ref.currentDataSource;
      var order = sorter.order || "descend";
      console.log(sorter, 'sorter');
      if (sorter.columnKey == 'lastUpdateTime') {
        this.queryParam.type = 1;
      } else {
        this.queryParam.type = 2;
      }
      this.queryParam.sort = order == 'ascend' ? 1 : 0;
      console.log(this.queryParam, 'query');
      this.getProductList();
    },
    changeType: function changeType(value) {
      console.log(value);
      this.getProductList();
    },
    searchProduct: function searchProduct(value) {
      console.log(value);
      this.getProductList();
    },
    editProduct: function editProduct(row) {
      var routeData = this.$router.resolve({
        path: '/productmanager/productDetail',
        query: {
          id: row.productId
        }
      });
      window.open(routeData.href, '_blank');
    }
  }
};